import React from "react";

// region Atoms
import Loading from "@atoms/Loading";
// endregion Atoms
// region Languages
import useTranslation from "@languages/useTranslation";
// endregion Languages

import { LegacyMigrationMessages } from "../languages/interfaces";
import * as Styled from "../styles";

interface IReadingProps {
  tenantName: string;
}

/**
 * Step 2 — the legacy database is being read.
 *
 * Nothing is asked of the operator, and there is nothing to cancel: the read is
 * one request, it changes nothing in the customer's database, and leaving the
 * screen drops it.
 */
const Reading: React.FC<IReadingProps> = ({ tenantName }) => {

  // region Hooks
  const { t } = useTranslation();
  // endregion Hooks

  return (
    <Styled.Card>
      <Styled.Centered>
        <Loading loading />

        <Styled.StepTitle>
          {t(LegacyMigrationMessages.legacyMigrationReadingTitle, { tenant: tenantName })}
        </Styled.StepTitle>

        <Styled.StepHint>{t(LegacyMigrationMessages.legacyMigrationReadingHint)}</Styled.StepHint>
      </Styled.Centered>
    </Styled.Card>
  );
};

export default Reading;
